<template>
  <div class="card-back flex-column flex-justify-center flex-align-center" :class="[{'card-gap': gap}]" :style="{backgroundColor: backColor}">
    <div class="cb-line flex-row flex-justify-start flex-align-center">
      <div class="card-tab flex-row flex-justify-start flex-align-center">
        <span class="card-font">{{ cardTitle }}</span>
      </div>
      <div class="card-tab flex-row flex-justify-start flex-align-center">
        <span class="card-font">{{ meterNum }}</span>
      </div>
    </div>
    <div class="cb-line flex-row flex-justify-start flex-align-center">
      <div class="card-tab flex-row flex-justify-start flex-align-center">
        <span class="card-font">{{ meterValue }}</span>
      </div>
      <div class="card-tab flex-row flex-justify-start flex-align-center">
        <span class="card-font">{{ meterFault }}</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'EngeryCard',
  props: {
    backColor: {
      type: String,
      default: '#ffffff'
    },
    cardTitle: {
      type: String,
      default: ''
    },
    meterNum: {
      type: String,
      default: ''
    },
    meterValue: {
      type: String,
      default: ''
    },
    meterFault: {
      type: String,
      default: ''
    },
    gap: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style scoped>
.card-gap {
  margin-right: 1%;
}
.card-back {
  width: 24.25%;
  border-radius: 10px;
  min-width: 400px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.4);
}
.card-back:hover {
  cursor: pointer;
  animation: an-card-hover 0.2s forwards;
}
@keyframes an-card-hover {
  0% { width: 24.25%; height: 120px;}
  100% { width: 24.5%; height: 125px;}
}
.cb-line {
  width: 100%;
  height: 60px;
}
.card-tab {
  width: 50%;
}
.card-font {
  color: #fff;
  font-family: 'Arial';
  font-size: 20px;
  margin-left: 20px;
}
</style>